import { useMutation } from '@tanstack/react-query';

import { postReset } from '../api';
import { ResetFormData } from './reset.schema';

export const usePostReset = (pharmacyId: string) => {
  const mutation = useMutation({
    mutationFn: (formData: ResetFormData) => postReset(pharmacyId, formData),
  });

  return {
    requestReset: mutation.mutate,
    reset: mutation.reset,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
  };
};
